/**
 * Optimistic (client-minted) message ids (#2234).
 *
 * useSendRoomMessage mints `temp-<ts>-<uuid>` rows for instant rendering.
 * They are NOT server resources: actions against them (delete/report) 404,
 * and read-anchoring must skip their client wall-clock timestamps. Mirrors
 * mobile's isOptimisticId (mobile/src/lib/chat.ts).
 *
 * The prefix is load-bearing across useRoomMessages (mint + swap/rollback),
 * ClubChatPage (read anchoring), and lib/unreadDivider — keep in sync if it
 * ever changes.
 */
export const OPTIMISTIC_ID_PREFIX = 'temp-';

export function isOptimisticId(id: string): boolean {
  return id.startsWith(OPTIMISTIC_ID_PREFIX);
}
